export function LongPressDirective($timeout) {
  'ngInject';

  //Global variable, to cancel timer on touchend.
  let timer;

  return {
    restrict: 'A',
    link: link
  };
  
  function link($scope, $elm, $attrs) {
    $elm.bind('mousedown touchstart', () => {
      // Locally scoped variable that will keep track of the long press
      $scope.longPress = true;

      // We'll set a timeout for 600 ms for a long press
      timer = $timeout(() => {
        if ($scope.longPress) {
          // If the touchend event hasn't fired,
          // apply the function given in on the element's on-long-press attribute
          $scope.$apply(() => {
            $scope.$eval($attrs.onLongPress)
          });
        }
      }, 600);
    });

    $elm.bind('mouseup touchend', () => {
      // Prevent the onLongPress event from firing
      $scope.longPress = false;

      // Prevent on quick presses, unwanted onLongPress selection.
      $timeout.cancel(timer);

      // If there is an on-touch-end function attached to this element, apply it
      if ($attrs.onTouchEnd) {
        $scope.$apply(() => {
          $scope.$eval($attrs.onTouchEnd)
        });
      }
    });
  }
}


// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-form-button/src/plugins/onLongPress/onLongPress.directive.js